/** Thrown when `updateStatus` uses `expectedUpdatedAt` and the row changed meanwhile (§10.2). */
export const APPLICATION_STATUS_CONFLICT_CODE = 'APPLICATION_STATUS_CONFLICT' as const;

export class ApplicationStatusConflictError extends Error {
  readonly code = APPLICATION_STATUS_CONFLICT_CODE;
  readonly applicationId: string;

  constructor(
    applicationId: string,
    message = 'This application was updated elsewhere (another tab or user). Refresh and try again.',
  ) {
    super(message);
    this.name = 'ApplicationStatusConflictError';
    this.applicationId = applicationId;
  }
}

export function isApplicationStatusConflictError(e: unknown): e is ApplicationStatusConflictError {
  return e instanceof ApplicationStatusConflictError;
}
